import axios from "axios";

export const getAllCategories = async (country) => {
  try {
    const response = await axios.get(
      `${process.env.GATSBY_API_URL}/api/categories?country=${country}`
    );
    return response.data;
  } catch (error) {
    console.error(error);
  }
};
